import { createSlice } from '@reduxjs/toolkit';

interface InitialState {
  savedTrigger: number;
  closeTrigger: number;
}

const initialState: InitialState = {
  savedTrigger: 0,
  closeTrigger: 0,
};

export const globalClientModalSlice = createSlice({
  name: 'globalClientModal',
  initialState,
  reducers: {
    setGlobalClientModalSavedTrigger: (state) => ({ ...state, savedTrigger: state.savedTrigger + 1 }),
    setGlobalClientModalClosedTrigger: (state) => ({ ...state, closeTrigger: state.closeTrigger + 1 }),
  },
});

export const { setGlobalClientModalSavedTrigger, setGlobalClientModalClosedTrigger } = globalClientModalSlice.actions;

export default globalClientModalSlice.reducer;
